import * as React from "react";
import { ExternalLink } from "../../../../newcomponents/table/components/ExternalLink";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";

interface Props {}
export const CloudaccountCreateGCPConfigurationProjectId: React.FC<Props> = ({}) => {
  return (
    <>
      <ul className="pl-8">
        <li className="mb-6 list-decimal ml-4">
          Sign into the <ExternalLink url="https://console.cloud.google.com" label="GCP Console" disableCopy />.
        </li>
        <li className="mb-6 list-decimal ml-4">
          Copy the <span className="font-semibold">Project ID</span> from the Project info card.
        </li>
        <div
          className="flex items-center justify-center mb-4"
          style={{ width: 264, height: 235, border: "1px solid rgb(223, 223, 223)" }}
        >
          <img
            className="object-container"
            style={{ width: 264, height: 235 }}
            src={"/resources/howto/gcp_projectIdSteps.png"}
            alt={"how do I get my gcp project id?"}
          />
        </div>
        <CpFormItem>
          <CpLabel name={"gcp.projectId"}>Project ID</CpLabel>
          <CpInput name={"gcp.projectId"} style={{ width: 220 }} />
          <CpErrorWarning name={"gcp.projectId"} />
        </CpFormItem>
        <li className="list-decimal mt-6 mb-4 ml-4">You can close this wizard.</li>
      </ul>
    </>
  );
};
